<template>
    <main role="main" class="main search-results">
        <div class="container py-4">
            <h1>Återställ lösenord</h1>

            <div class="list-result container" v-if="!loading && status === 'ok'">
                <div class="row mt-2 px-10">
                    <form @submit.prevent="submit" class="w-full text-left">
                        <div class="w-full text-left">
                            <label class="control-label">Epost</label>
                            <input v-model="newPasswordForm.email" type="email" name="email" class="form-control">
                            <div v-if="newPasswordForm.errors.email" class="invalid-feedback d-block text-left">
                                {{ newPasswordForm.errors.email }}
                            </div>
                        </div>

                        <div class="w-full text-left mt-4">
                            <label class="control-label">Nytt lösenord</label>
                            <input v-model="newPasswordForm.password" type="password" name="password" class="form-control">
                            <div v-if="newPasswordForm.errors.password" class="invalid-feedback d-block text-left">
                                {{ newPasswordForm.errors.password }}
                            </div>
                        </div>

                        <div class="w-full text-left mt-4">
                            <label class="control-label">Nytt lösenord igen</label>
                            <input v-model="newPasswordForm.password_confirmation" type="password" name="password_confirmation" class="form-control">
                            <div v-if="newPasswordForm.errors.password_confirmation" class="invalid-feedback d-block text-left">
                                {{ newPasswordForm.errors.password_confirmation }}
                            </div>
                        </div>

                        <button type="button" class="btn btn-danger mt-4" v-if="newPasswordForm.processing">Laddar...</button>
                        <input type="submit" class="btn btn-danger mt-4" value="Skicka" v-if="!newPasswordForm.processing">
                    </form>
                </div>
            </div>

            <div v-if="!loading && status === 'error'" class="mt-5 mb-5" style="font-size: 24px;">
                Denna länk är inte längre giltig.
            </div>

            <div v-if="loading">
                <i class="fas fa-circle-notch fa-spin" style="font-size: 50px;"></i>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        inject: ['$isMobile'],
        props: ['token'],
        data () {
            return {
                loading: true,
                status: null,
                newPasswordForm: this.$inertia.form({
                    token: this.token,
                    email: null,
                    password: null,
                    password_confirmation: null,
                }),
            }
        },

        created () {
            this.validateResetToken()
        },

        methods: {
            validateResetToken () {
                axios.get(`/api/password/reset/${this.newPasswordForm.token}`).then(response => {
                    this.status = response.data.status;
                    this.loading = false;
                });
            },

            submit() {
                this.newPasswordForm.post(`/password/reset/${this.newPasswordForm.token}`);
            }
        }
    }
</script>
